<template>
  <div class="ha-project-results">
    This is the project results page
  </div>
</template>

<script>
export default {
  name: "ProjectResults"
}
</script>

<style scoped>

</style>